import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from "../../shared/services/auth.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(
    public authService: AuthService,
    public router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn !== true) {
      this.router.navigate(['sign-in'])
    } {
      // admin no finance privilege and users privilege edit
      if (this.authService.getUserProfile) {
        if (!state.url.includes('dashboard')) {
          if (!this.authService.getUserProfile.admin && this.authService.getUserProfile.storage && !state.url.includes('storage')) {
            state.url.includes('orders') || this.authService.getUserProfile.sales ? null : this.router.navigate(['storage'])
          }
          if (!this.authService.getUserProfile.admin && this.authService.getUserProfile.sales && !state.url.includes('sales')) {
            state.url.includes('orders') || this.authService.getUserProfile.storage || this.authService.getUserProfile.approver ? null : this.router.navigate(['sales'])
          }
        }
      }
    }
    return true;
  }

}